import React from 'react';
import { Button } from '@shared/ui/button';
import { Check, Download, Mail, Printer } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const ConfirmationStep = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center max-w-2xl mx-auto pb-10">
      <div className="bg-white rounded-2xl border p-10 w-full flex flex-col items-center text-center shadow-sm">
        
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
          <div className="w-8 h-8 rounded-full border-2 border-green-600 flex items-center justify-center text-green-600">
            <Check className="w-5 h-5 stroke-[3]" />
          </div>
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-3">Payment Successful!</h2>
        
        <p className="text-gray-500 mb-8 max-w-md text-sm">
          Your payment has been processed successfully. A receipt has been sent to your registered email.
        </p>

        <div className="w-full bg-gray-50/80 rounded-xl p-6 mb-8 text-left space-y-4">
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-500">Transaction ID</span>
            <span className="font-bold text-gray-900">TXN-PAY-6982782</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-500">Consumer</span>
            <span className="text-gray-900 font-medium">Michael R. Johnson</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-500">Bills Paid</span>
            <span className="text-gray-900 font-medium">2 bill(s)</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-500">Date & Time</span>
            <span className="text-gray-900 font-medium">7/13/2026, 12:19:54 PM</span>
          </div>
          
          <div className="pt-4 mt-2 border-t flex justify-between items-center">
            <span className="font-bold text-gray-900 text-sm">Amount Paid</span>
            <span className="font-bold text-green-600 text-xl">$170.73</span>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <Button variant="outline" className="text-blue-600 border-blue-200 hover:bg-blue-50 flex items-center gap-2">
            <Download className="w-4 h-4" /> Download Receipt
          </Button>
          <Button variant="ghost" className="text-gray-600 hover:text-gray-900 flex items-center gap-2">
            <Mail className="w-4 h-4" /> Email Receipt
          </Button>
          <Button variant="ghost" className="text-gray-600 hover:text-gray-900 flex items-center gap-2">
            <Printer className="w-4 h-4" /> Print Receipt
          </Button>
        </div>
      </div>

      <div className="flex items-center gap-4 mt-8">
        <Button variant="outline" onClick={() => navigate('/dashboard/billing')} className="border-gray-300 text-gray-700 h-10 px-6 rounded-md">
          Back to Bill Search
        </Button>
        <Button variant="outline" onClick={() => navigate('/dashboard/requests')} className="border-blue-200 text-blue-600 h-10 px-6 rounded-md hover:bg-blue-50 bg-white">
          Raise a Complaint
        </Button>
      </div>
    </div>
  );
};
